export function accordion(
  accordionEl,
  accordionButtonEl,
  accordionItemEl,
  isChildren
) {
  if (
    $(accordionEl).length &&
    $(accordionButtonEl).length &&
    $(accordionItemEl).length
  ) {
    $(accordionEl)
      .children(accordionButtonEl)
      .on("click", function () {
        $(this).toggleClass("active");
        if (isChildren) {
          $(this).children(accordionItemEl).slideToggle();
        } else {
          $(this).next(accordionItemEl).fadeToggle();
        }
      });
    $(document).on("click touchend", function (event) {
      // 表示したポップアップ以外の部分をクリックしたとき
      if (!$(event.target).closest(accordionButtonEl).length) {
        $(accordionItemEl).fadeOut();
      }
    });
  }
}
